export default {
  currentUser: localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null,
  profile: null,
};
